import axios from "axios";
import { Urls } from "../apiUrls/apiUrl";
import { toast } from "react-toastify";

export const AUTENTICATE_API = {
  customerLogin,
  modulesList,
  createRole,
  updateRole,
  getRoles,
  getRoleById,
  getEmployees,
  getEmployeeDesignations,
  getEmployeeNames,
  getEmployeeDetails,
  createEmployee,
  updateEmployee,
};

function customerLogin(requestOptions) {
  return axios
    .post(`${Urls}user_login`, requestOptions)
    .then((response) => response.data)
    .catch(handleError); // Use a common error handler
}

function modulesList() {
  return axios
    .get(`${Urls}get_modules`)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function getRoles() {
  return axios
    .get(`${Urls}get_role_permission`)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}

function createRole(payload) {
  return axios
    .post(`${Urls}create_role_permission`, payload)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function updateRole(payload) {
  return axios
    .patch(`${Urls}update_role_permission`, payload)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function getRoleById(role_id) {
  return axios
    .get(`${Urls}get_rolebyrole/${role_id}`)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function getEmployees() {
  return axios
    .get(`${Urls}get_employee`)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}

function getEmployeeDesignations() {
  return axios
    .get(`${Urls}get_employee_designation`)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function getEmployeeNames() {
  return axios
    .get(`${Urls}get_employee_name`)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function getEmployeeDetails(empId) {
  return axios
    .get(`${Urls}get_employeebyId/${empId}`)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function createEmployee(payload) {
  return axios
    .post(`${Urls}create_employee`, payload)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function updateEmployee(payload) {
  return axios
    .patch(`${Urls}update_employee`, payload)
    .then((response) => response.data)
    .catch(handleError); // Use the same common error handler
}
function handleError(error) {
  if (!error.response) {
    // If the error response is undefined
    toast.error("An unexpected error occurred", { autoClose: 2000 });
    return [];
  }

  const { status, data } = error.response;

  // Map status codes to error messages
  const errorMessages = {
    401: "User nicht gefunden",
    400: data?.error || "Bad request",
    404: data?.message || "Resource not found",
    409: data?.message || "Conflict occurred",
    500: data?.message || "Internal server error",
  };

  // Default error message if status is not mapped
  const errorMessage = errorMessages[status] || "An error occurred";

  toast.error(errorMessage, { autoClose: 2000 });
  return [];
}
